import blkmartLogo from "@assets/5AC8CAF3-865C-4734-AAF2-5AF05243F749_1760725612036.png";
import { Helmet } from 'react-helmet-async';

export default function BlkMartPage() {
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ 
        background: 'url(/blkmart-bg-tile.png) repeat',
        backgroundColor: '#faf8f6'
      }}
    >
      <Helmet>
        <title>BLKMART - Discover, Support, Thrive | BlackBook</title>
        <meta name="description" content="BLKMART - Your marketplace for Black-owned products and services. Discover, Support, Thrive." />
        
        <meta property="og:title" content="BLKMART - Discover, Support, Thrive | BlackBook" />
        <meta property="og:description" content="Your marketplace for Black-owned products and services." />
        <meta property="og:image" content="https://www.blackbook.family/logo.jpeg" />
        <meta property="og:url" content="https://www.blackbook.family/blkmart" />
        <meta property="og:type" content="website" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="BLKMART - Marketplace" />
        <meta name="twitter:description" content="Discover, Support, Thrive" />
        <meta name="twitter:image" content="https://www.blackbook.family/logo.jpeg" />
      </Helmet>
      <div className="text-center px-4">
        <img 
          src={blkmartLogo} 
          alt="BLKMART - Discover, Support, Thrive" 
          className="w-full max-w-2xl mx-auto"
          data-testid="img-blkmart-logo"
        />
      </div>
    </div>
  );
}
